import React from 'react'
import PropTypes from 'prop-types'

import { AppBar, Box, Button, Toolbar, Typography } from '@mui/material'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faAngleLeft } from '@fortawesome/free-solid-svg-icons'
import { NEW_CONTAINER_WIDTH } from 'constants/layoutConstant'
import closeIcon from 'images/closeIcon.svg'
import { MESSAGES } from '../messages/messages'

const UploadHeader = ({ headerName = '', clickHandler = () => {} }) => {
    return (
        <AppBar
            component="header"
            position="sticky"
            data-testid="upload-preview-header"
            sx={{
                backgroundColor: 'background.default',
                boxShadow: 'initial',
                borderRadius: 0,
                zIndex: 2,
                pt: 6,
                pb: 4,
                px: 4
            }}
        >
            <Toolbar
                disableGutters
                sx={{
                    justifyContent: 'space-between',
                    minHeight: { xs: 24 },
                    maxWidth: NEW_CONTAINER_WIDTH,
                    px: { xs: 0, md: 10 },
                    m: 'auto',
                    width: '-webkit-fill-available'
                }}
            >
                {headerName === 'Drivers License' || headerName === 'Edit' ? (
                    <Button
                        tabIndex={0}
                        aria-label="back"
                        variant="text"
                        disableRipple
                        data-testid="back"
                        onClick={clickHandler}
                        sx={{
                            color: 'common.link.light',
                            display: 'flex',
                            alignItems: 'center',
                            gap: 3,
                            p: 0
                        }}
                    >
                        <FontAwesomeIcon icon={faAngleLeft} size="xl" />

                        <Typography
                            sx={{
                                display: 'flex',
                                typography: 'boldBody2',
                                mt: 0.6,
                                color: 'common.link.light'
                            }}
                            component="span"
                        >
                            {MESSAGES.back}
                        </Typography>
                    </Button>
                ) : (
                    <>
                        <Typography
                            tabIndex={0}
                            role="none"
                            aria-label="Upload Doc Tittle"
                            data-testid="upload_doc_title"
                            sx={{
                                color: 'common.fordTwilight.main',
                                justifySelf: 'center',
                                typography: 'mediumBody1'
                            }}
                        >
                            {headerName}
                        </Typography>

                        <Box
                            sx={{
                                display: 'flex',
                                alignItems: 'center',
                                position: 'absolute',
                                top: 0,
                                right: 0
                            }}
                        >
                            <Button
                                tabIndex={0}
                                aria-label="back"
                                variant="text"
                                disableRipple
                                data-testid="back"
                                onClick={clickHandler}
                                sx={{
                                    color: 'primary.main',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'flex-end',
                                    gap: 2,
                                    width: 'max-content',
                                    padding: 0
                                }}
                            >
                                <img src={closeIcon} alt={'close modal'} width={24} height={24} />
                            </Button>
                        </Box>
                    </>
                )}
            </Toolbar>
        </AppBar>
    )
}

UploadHeader.propTypes = {
    headerName: PropTypes.string,
    clickHandler: PropTypes.func
}

export default UploadHeader
